import Vue from 'vue'
import Router from 'vue-router'
import store from "../store"; 

// cts imports
import InboxView from '../views/InboxView.vue'
import ManageEntityRecipients from '@/views/admin/ManageEntityRecipients.vue'
import HomeView from '../views/Home.vue'
import InboxUserView from '../views/InboxUserView.vue'
import InboxStructureView from '../views/InboxStructureView.vue'
import CcedView from '../views/CcedView.vue'
import SaveForLaterView from '../views/SaveForLaterView.vue'
import Dashboard from '../views/Dashboard'
import DashboardsView from '../views/DashboardsView.vue'
import AverageCompletionDashboard from '../components/cts-dashboards/AverageCompletionDashboard.vue';
import AverageDelayDashboard from '../components/cts-dashboards/AverageDelayDashboard.vue';
import CorrespondenceDashboard from '../components/cts-dashboards/CorrespondenceDashboard.vue';
import UsersDashboards from '../components/cts-dashboards/UsersDashboards.vue';
import DepartmentActivityDashboard from '../components/cts-dashboards/DepartmentActivityDashboard.vue';
import CorrespondenceTypeDashboard from '../components/cts-dashboards/CorrespondenceTypeDashboard.vue';
import SelectedTemplateDashboard from '../components/cts-dashboards/SelectedTemplateDashboard.vue';
import DraftView from '../views/DraftView.vue'
import SentView from '../views/SentView.vue'
import AllSentView from '../views/AllSentView.vue'
import FollowUpView from '../views/FollowUpView.vue'
import ArchiveView from '../views/ArchiveView.vue'
import AdvancedSearch from '../views/AdvancedSearch.vue'
import CreateDocumentView from '../views/CreateDocumentView.vue'
import UserDashboardsView from '../views/UserDashboards.vue'
import EditTemplateView from '../views/EditTemplateView.vue'
import ManageCorrespondenceView from '../views/ManageCorrespondenceView.vue'
import TrackingView from '../views/TrackingView.vue'
import AddressBookView from '../views/AddressBookView.vue'
import DeliveryNote from '../views/DeliveryNotesView.vue'
// import Search from '../views/SearchView.vue'
import Reports from '../views/Reports/Reports.vue'
import AuditTrails from '../views/admin/AuditTrails.vue'
import Report from '../views/Reports/Report.vue'
import Delegations from '../views/Delegations.vue'
import DsReturn from '../views/DsReturn.vue' 
import AdminMainView from '../views/admin/MainView.vue'
import ManageMoveUser from '../views/admin/ManageMoveUser.vue'
import ManageMoveStructure from '../views/admin/ManageMoveStructure.vue'
import MoveCorrespondences from '../views/admin/MoveCorrespondences.vue'
import ManagePublicAnnouncements from '../views/admin/ManagePublicAnnouncements.vue'
import AttachmentVersions from '../components/AttachmentVersions.vue'
import AuditActions from '../views/admin/AuditActions.vue'
import OrganizationManagement from '../views/admin/OrganizationManagement.vue'
import ManageUsers from '../views/admin/ManageUsers.vue'
import ManageCorrespondences from '../views/admin/ManageCorrespondences.vue'
import SystemDelegation from '../views/admin/SystemDelegationView.vue'
import LookupsView from '../views/admin/LookupsView.vue'
import SystemParametersView from '../views//admin/SystemParametersView.vue'
import ActionsView from '../views/admin/ActionsView.vue'
import ManageRoles from '../views/admin/ManageRoles.vue'
import ManageDispatchEntities from '../views/admin/ManageDispatchEntities.vue'
import test from '../views/test.vue'
import ManageCounter from '@/views/admin/ManageCounter.vue'
import ManageRefernceFormat from '@/views/admin/ManageRefernceFormat.vue'
import ManageExternalEntities from '../views/admin/ManageExternalEntities.vue'
import ManageNotificationTemplates from '../views/admin/ManageNotificationTemplates.vue'
import ManageResources from '../views/admin/ManageResources.vue' 
import ManageSystemLookups from '../views/admin/ManageSystemLookups.vue'
import ManageDocumentLooups from '../views/admin/ManageDocumentLooups.vue'
import ToDoLists from '../views/ToDoLists.vue' 
import ManageCommittees from '../views/admin/ManageCommittees.vue' 
import BulkCreateView from '../views/custom/BulkCreateView.vue'

import constants from '@/assets/js/constants';
import axios from 'axios';
Vue.use(Router)

var ctsRoutes = [
	{ path: '/', name: 'inbo', component: InboxView, meta: {  customData: {permissionName: "*"} } },
	{ path: '/home', name: 'home', component: HomeView, meta: {  customData: {permissionName: "*"} } },
	{ path: '/inbox/:name?', name: 'inbox', component: InboxView, meta: {  customData: {permissionName: "*"} } },
	{ path: '/inbox-user', name: 'inboxUser', component: InboxUserView, meta: {  customData: {permissionName: "*"} } },
	{ path: '/inbox-structure', name: 'inboxStructure', component: InboxStructureView, meta: {  customData: {permissionName: "*"} } },
	{ path: '/cced', name: 'cced', component: CcedView, meta: {  customData: {permissionName: "*"} } },
	{ path: '/hidden-inbox', name: 'hiddenInbox', component: SaveForLaterView, meta: {  customData: {permissionName: "HiddenInbox"} } },
	{ path: '/draft', name: 'draft', component: DraftView, meta: {  customData: {permissionName: "Draft"} } },
	{ path: '/sent', name: 'sent', component: SentView, meta: {  customData: {permissionName: "Sent"} } },
	{ path: '/all-sent', name: 'all-sent', component: AllSentView, meta: {  customData: {permissionName: "All Sent"} } },
	{ path: '/followup', name: 'followup', component: FollowUpView, meta: {  customData: {permissionName: "FollowUp"} } },
	{ path: '/archive', name: 'archive', component: ArchiveView, meta: {  customData: {permissionName: "Archive"} } },
	{ path: '/advancedsearch', name: 'advancedsearch', component: AdvancedSearch, meta: {  customData: {permissionName: "AdvancedSearch"} } },

	{ path: '/tasks-list', name: 'ToDoLists', component: ToDoLists, meta: {  customData: {permissionName: "*"} } },
	{ path: '/create', name: 'createDocument', component: CreateDocumentView, meta: {  customData: {permissionName: "*"} } },
	{ path: '/user-dashboard', name: 'userDashboard', component: UserDashboardsView, meta: {  customData: {permissionName: "!"} } },
	{ path: '/edit-template', name: 'editTemplate', component: EditTemplateView, meta: {  customData: {permissionName: "*"} } },
	{ path: '/manage-correspondence', name: 'manageCorrespondence', component: ManageCorrespondenceView, meta: {  customData: {permissionName: "*"} } },
	{ path: '/tracking', name: 'tracking', component: TrackingView, meta: {  customData: {permissionName: "*"} } },
	{ path: '/delivery-note', name: 'deliveryNote', component: DeliveryNote, meta: {  customData: {permissionName: "DeliveryNote"} } },
	{ path: '/address-book', name: 'address-book', component: AddressBookView, meta: {  customData: {permissionName: "*"} } },
	// { path: '/search', name: 'search', component: Search, meta: {  customData: {permissionName: "*"} } },
	{ path: '/dsReturn', name: 'dsReturn', component: DsReturn, meta: {  customData: {permissionName: "*"} } },
	{ path: '/bulk-create', name: 'bulkCreate', component: BulkCreateView, meta: {  customData: {permissionName: "*"} } },
	{ 
		path: '/reports', name: 'reports', component: Reports, meta: {  customData: {permissionName: "Reports"} }, children: [
			{ path: 'report', name: 'report', component: Report, meta: {  customData: {permissionName: "Reports"} } }
		]
	},
	{ path: '/delegation', name: 'delegation', component: Delegations, meta: {  customData: {permissionName: "Delegation"} } },
	{
		path: '/admin', name: 'admin', component: AdminMainView, meta: {  customData: {permissionName: "Admin"} }, children: [
			{ path: 'organization', name: 'organization', component: OrganizationManagement, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'manage-entity-recipients', name: 'manageEntityRecipients', component: ManageEntityRecipients, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'manage-users', name: 'manageUsers', component: ManageUsers, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'manage-correspondences', name: 'manageCorrespondences', component: ManageCorrespondences, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'system-delegation', name: 'systemDelegation', component: SystemDelegation, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'manage-custom-lookups', name: 'manageCustomLookups', component: LookupsView, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'system-parameters', name: 'systemParameters', component: SystemParametersView, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'actions', name: 'actions', component: ActionsView, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'manage-roles', name: 'manageRoles', component: ManageRoles, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'manage-dispatch-entities', name: 'manageDispatchEntities', component: ManageDispatchEntities, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'manage-counter', name: 'manageCounter', component: ManageCounter, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'manage-refernce-format', name: 'manageRefernceFormat', component: ManageRefernceFormat, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'manage-external-entities', name: 'manageExternalEntities', component: ManageExternalEntities, meta: {  customData: {permissionName: "*"} } },
		    { path: 'manage-notification-templates', name: 'manageNotificationTemplates', component: ManageNotificationTemplates, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'manage-resources', name: 'ManageResources', component: ManageResources, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'manage-system-lookups', name: 'manageSystemLookups', component: ManageSystemLookups, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'manage-document-lookups/:pagenum', name: 'managedocumentlookups', component: ManageDocumentLooups, meta: {  customData: {permissionName: "Admin"} } },
			{ path: 'manage-committees', name: 'ManageCommittees', component: ManageCommittees, meta: {  customData: {permissionName:"Admin"} } },
			{ path: 'audit-actions', name: 'AuditActions', component: AuditActions, meta: {  customData: {permissionName:"Admin"} } },
			{ path: 'move-user', name: 'ManageMoveUser', component: ManageMoveUser, meta: {  customData: {permissionName:"Admin"} } },
			{ path: 'move-structure', name: 'ManageMoveStructure', component: ManageMoveStructure, meta: {  customData: {permissionName:"Admin"} } },
			{ path: 'move-correspondences', name: 'MoveCorrespondences', component: MoveCorrespondences, meta: {  customData: {permissionName:"Admin"} } },
			{ path: 'manage-public-announcements', name: 'ManagePublicAnnouncements', component: ManagePublicAnnouncements, meta: {  customData: {permissionName:"Admin"} } },
			{ path: 'AttachmentVersions', name: 'AttachmentVersions', component: AttachmentVersions, meta: {  customData: {permissionName:"Admin"} } },
			{ 
				path: 'audits', name: 'AuditTrails', component: AuditTrails, meta: {  customData: {permissionName: "Admin"} }, children: [
					{ path: 'audit', name: 'audit', component: Report, meta: {  customData: {permissionName: "Admin"} } }
				]
			},
		]
	},
	{
		path: '/dashboard', name: 'dashboards', component: DashboardsView, meta: {  customData: {permissionName: "Dashboard"} }, children: [
			{ path: 'general', name: 'dashboard', component: Dashboard, meta: {  customData: {permissionName: "Dashboard"} } },
			{ path: 'average-completion-dashboard', name: 'average-completion-dashboard', component: AverageCompletionDashboard, meta: {  customData: {permissionName: "Dashboard"} } },
			{ path: 'average-delay-dashboard', name: 'average-delay-dashboard', component: AverageDelayDashboard, meta: {  customData: {permissionName: "Dashboard"} } },
			{ path: 'correspondence-dashboard', name: 'correspondence-dashboard', component: CorrespondenceDashboard, meta: {  customData: {permissionName: "Dashboard"} } },
			{ path: 'users-dashboard', name: 'users-dashboard', component: UsersDashboards, meta: {  customData: {permissionName: "Dashboard"} } },
			{ path: 'department-dashboard', name: 'department-dashboard', component: DepartmentActivityDashboard, meta: {  customData: {permissionName: "Dashboard"} } },   
			{ path: 'type-dashboard', name: 'type-dashboard', component: CorrespondenceTypeDashboard, meta: {  customData: {permissionName: "Dashboard"} } },   
			{ path: 'template-dashboard', name: 'template-dashboard', component: SelectedTemplateDashboard, meta: {  customData: {permissionName: "Dashboard"} } },       
		]
	},
	{ path: '/test', name: 'test', component: test, meta: {  customData: {permissionName: "*"} } }
]

const router = new Router({ mode: 'history', base: process.env.BASE_URL, routes: [] })
ctsRoutes.forEach(route => router.addRoute(route))

router.beforeEach(async (to, from, next) => {
	if(constants.userActions.menu == undefined){
		constants.isPermissionsLoaded = false
		await axios.get(constants.baseApiUrl + 'User/GetUserActions?applicationId=' + window.defaultApplicationId)
		.then(res =>
		{
			res.data.menu = res.data.menu.filter(x => x.settings != null);
			res.data.menu.forEach(x=> {
				x.menuItems = JSON.parse(x.settings);
			});
			constants.userActions = res.data;
			constants.isFullAdmin = res.data.isFullAdmin;
			constants.isCompanyAdmin = res.data.isCompanyAdmin;
			constants.isManager = res.data.isManager;
			constants.isSecretary = res.data.isSecretary;
			constants.isPermissionsLoaded = true
			let hasInbox = constants.userActions.menu.some(x=>x.name.toLowerCase() == "inbox")
			let admin = constants.userActions.menu.some(x=>x.name.toLowerCase() == "admin")

			if(to.name == "inbo" || to.name == "inbox"){
				if(!hasInbox )
				{
					if(admin)
						next({name:'admin'})
					else 
						next({name:'home'})
				}
			}
					
		})
		.catch(err => console.warn(err))
	}

	var hasAccess = 
		to.meta.customData &&
		to.meta.customData.permissionName &&
	(
		to.meta.customData.permissionName == "*" ||
		(
			constants.userActions.menu.some(f => f.name.toLowerCase() == to.meta.customData.permissionName.toLowerCase())
		)
	);
	
	if (!hasAccess) 
	{
	  	document.getElementById("logout").click();
		//next();
	}
	else
	{
		next();
	}
})

export default router